import { TableRow } from "@material-ui/core";
import { FC } from "react";
import { useStyles } from "../styles";
import { DriverData } from "types/DaAndFleet";
import { DA_TABLE_HEADERS_COLUMN } from "../tableData";
import { DAStatusCell } from "./DAStatusCell";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import useResize from "hooks/useResize";

interface FleetReportRowProps {
  row: DriverData;
  tableNumber: number;
}

export const DaStatusRow: FC<FleetReportRowProps> = ({ row, tableNumber }) => {
  const classes = useStyles();
  const { width } = useResize();
  const { userData } = useTypeSelectors((state) => state.auth);
  const {
    driverData: { driverListFilters, idListForUpdate },
  } = useTypeSelectors((state) => state.daAndFleets);

  return (
    <TableRow
      key={`${row.badge}-${row.transporter_id}`}
      className={idListForUpdate.includes(row.id) ? classes.activeRow : ""}
    >
      {DA_TABLE_HEADERS_COLUMN.filter((col) =>
        width > 840
          ? col.table === tableNumber
          : tableNumber === 1
            ? ["checkbox"].includes(col.id)
            : !["checkbox"].includes(col.id) || ["full_name", "badge"].includes(col.id),
      )
        ?.filter((col: any) =>
          driverListFilters?.activeColumns?.length
            ? width > 840
              ? driverListFilters?.activeColumns?.includes(col.id) ||
                ["checkbox", "full_name", "badge"].includes(col.id)
              : driverListFilters?.activeColumns?.includes(col.id) || ["checkbox"].includes(col.id)
            : true,
        )
        .map((item) => DAStatusCell(item.id, row, classes, userData.role,))}
    </TableRow>
  );
};
